export const PaymentTransaction = (json: IPaymentTransaction): IPaymentTransactionModel => {
	const fromJSON = (paymentTransaction: IPaymentTransaction) => {
		const {
			client,
			client_profile,
			date,
			transaction_id,
			payment_method,
			cart,
			wallet_discount,
			amount_total,
			wallet_top_up_amount,
			wallet_cashback_amount,
			wallet_promo_amount,
			...rest
		} = paymentTransaction
		return {
			client: client ? clientFromJSON(client) : null,
			clientProfile: client_profile ? ClientProfile(client_profile) : null,
			date: new Date(date),
			transactionID: transaction_id,
			paymentMethod: payment_method,
			cart: cart ? Cart(cart) : null,
			walletDiscount: wallet_discount ?? 0,
			amountTotal: amount_total ?? 0,
			walletTopUpAmount: wallet_top_up_amount ?? 0,
			walletCashbackAmount: wallet_cashback_amount ?? 0,
			walletPromoAmount: wallet_promo_amount ?? 0,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}
